import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ListGroup, ListGroupItem, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import exact from 'prop-types-exact';
import _ from 'lodash';

import './AllUsersList.css';

const propTypes = exact({
  allUsers: PropTypes.array.isRequired,
  setUserIdAction: PropTypes.func.isRequired,
  currentUserId: PropTypes.number,
});

class AllUsersList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filteredUserArray: this.props.allUsers,
    };
  }

  onNameChange(e) {
    const { allUsers } = this.props;

    const filteredUserArray = _.filter(allUsers, (user) => {
      const fullname = user.fullname.toUpperCase();
      const targetValue = e.target.value.toUpperCase();
      return (
        fullname.includes(targetValue)
      );
    });
    this.setState({ filteredUserArray });
  }

  render() {
    const { setUserIdAction, currentUserId } = this.props;

    return (
      <div>
        <FormGroup>
          <ControlLabel>
            Filter by Name:
          </ControlLabel>
          <FormControl
            type="text"
            onChange={(e) => { return this.onNameChange(e); }}
          />
        </FormGroup>

        <div>
          <ListGroup className="allUserList-scroll-bar">
            {this.state.filteredUserArray.map((item) => {
              const isActive = (item.id === currentUserId);
              return (
                <ListGroupItem
                  className={`list-group-item ${isActive ? 'active' : ''}`}
                  key={item.id}
                  onClick={() => {
                    return setUserIdAction(item.id);
                  }}
                >
                  {item.fullname}
                </ListGroupItem>
              );
            })}
          </ListGroup>
        </div>
      </div>
    );
  }
}

AllUsersList.propTypes = propTypes;
AllUsersList.defaultProps = {};

export default (AllUsersList);
